// extracted by mini-css-extract-plugin
export default {"cta":"_J-z","disabled":"aK-z"};